import { combineReducers } from 'redux';
import clipReducer from './clip/clip-reducer';
import appReducer from './app/app-reducer';
import configReducer from './config/config-reducer';
import listReducer from './list/list-reducer';
import topicReducer from './topic/topic-reducer';
import appRuntimeConfigReducer from './config/runtime-config-reducer';
import subnavReducer from './subnav/subnav-reducer';
import searchReducer from './search/search-reducer';

const rootReducer = combineReducers({
    clip: clipReducer,
    app: appReducer,
    mediaConfig: configReducer,
    list: listReducer,
    topic: topicReducer,
    appRuntimeConfig: appRuntimeConfigReducer,
    search: searchReducer,
    subnav: subnavReducer,
});

export default rootReducer;
